import { Button, Icon, IconProps } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';

export default function EmptyTabContent({
  title,
  description,
  icon,
}: {
  title: string;
  description: string;
  icon: IconProps['name'];
}) {
  const navigate = useNavigate();
  const { t } = useTranslation('app');
  const { VALUATION_URL } = useFullRoutes();

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="mx-auto flex max-w-[524px] flex-col items-center text-center">
        <Icon name={icon} size="80" className="text-blue mb-2x" />
        <h2 className=" mb-1.5x text-title_4 ">{title}</h2>
        <p className=" text-body_1  text-gray__dark_2 mb-3x">{description}</p>
        <Button
          variant="primary"
          size="medium"
          onClick={() => navigate(VALUATION_URL.ADD)}
        >
          {t('addFirstValuation')}
        </Button>
      </div>
    </div>
  );
}
